/** Last viewed Find group — persisted per user for instant session resume. */

export function findSelectedGroupStorageKey(userId) {
  return `prii-find-selected-group-${userId ?? 'anon'}`;
}

export function readStoredFindGroupId(userId) {
  if (!userId || typeof window === 'undefined') return null;
  try {
    return localStorage.getItem(findSelectedGroupStorageKey(userId)) || null;
  } catch {
    return null;
  }
}

export function writeStoredFindGroupId(userId, groupId) {
  if (!userId || typeof window === 'undefined') return;
  try {
    if (groupId) {
      localStorage.setItem(findSelectedGroupStorageKey(userId), groupId);
    } else {
      localStorage.removeItem(findSelectedGroupStorageKey(userId));
    }
  } catch {
    // ignore quota / private mode
  }
}
